module.exports = __webpack_public_path__ + "img/wellness_banner.4abd94a2.png";